import React, { useCallback, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import {
  collection,
  doc,
  getFirestore,
  limit,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";
import { useParams } from "react-router-dom";
import { ScrollShadow } from "@nextui-org/react";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
  Divider,
  Link,
  Image,
  Badge,
  cn,
} from "@nextui-org/react";
import he from "he";
import { addDays, format } from "date-fns";
import QRCode from "qrcode.react";

type RoomParams = {
  id: string;
};

type infoSolicitarPresenca = {
  sessao: {
    id: string;
    dataSessao: string;
    legislatura: string;
    periodo: string;
    sessao: string;
    statusConfigSessao: number;
    statusSessao: string;
    tipoSessao: string;
  };
};

export function LeituraPautas({ sessao }: infoSolicitarPresenca) {
  const params = useParams<RoomParams>();
  const roomId = params.id;

  const scrollRef = useRef(null);
  const audioRef = useRef(null);

  const simplesOptions = [
    {
      label: "Projeto de resolução",
      value: "projetoResolucao",
    },
    {
      label: "Emenda",
      value: "emenda",
    },
    {
      label: "Indicação",
      value: "indicacao",
    },
    {
      label: "Projeto de Decreto Legislativo",
      value: "projetoDecretoLegislativo",
    },
    {
      label: "Projeto de emenda à Lei orgânica",
      value: "projetoEmendaLeiOrganica",
    },
    {
      label: "Projeto de Lei Ordinária",
      value: "projetoLeiOrdinaria",
    },
    {
      label: "Projeto de Lei do Poder Executivo",
      value: "projetoLeiPoderExecutivo",
    },
    {
      label: "Projeto de Lei do Poder Legislativo",
      value: "projetoLeiPoderLegislativo",
    },
    {
      label: "Projeto Substitutivo",
      value: "projetoSubstitutivo",
    },
    {
      label: "Requerimento",
      value: "requerimento",
    },
    {
      label: "Subemenda",
      value: "subemenda",
    },
    {
      label: "Veto",
      value: "veto",
    },
    {
      label: "Pareceres das Comições",
      value: "pareceresComicoes",
    },
    {
      label: "Parecer",
      value: "parecer",
    },
    {
      label: "Mensagem",
      value: "mensagem",
    },
  ];

  const [pautasVis, setpautasVis] = useState({});
  const [time, setTime] = useState(new Date());
  const [presencaParlamentares, setPresencaParlamentares] = useState([]);

  useEffect(() => {
    const timer = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "presencaParlamentares"
    );

    onSnapshot(ordersRef, (querySnapshot) => {
      const parsedData = querySnapshot.docs.map((doc) => {
        const data = doc.data();

        return {
          id: doc.id,
          ...data,
        };
      });

      setPresencaParlamentares(parsedData as any);
    });
  }, []);

  const startAutoScroll = useCallback(() => {
    const scrollContainer = scrollRef.current;
    if (!scrollContainer) return;

    //@ts-ignore
    const scrollHeight = scrollContainer.scrollHeight;
    //@ts-ignore
    const clientHeight = scrollContainer.clientHeight;

    const scroll = () => {
      //@ts-ignore
      if (scrollContainer.scrollTop + clientHeight >= scrollHeight) {
        //@ts-ignore
        scrollContainer.scrollTop = 0;
      } else {
        //@ts-ignore
        scrollContainer.scrollBy({ top: 1, behavior: "smooth" });
      }
    };

    const intervalId = setInterval(scroll, 100);

    return () => clearInterval(intervalId);
  }, []);

  const stripHtml = (html: string) => {
    const decodedHtml = he.decode(html); // Decodifica entidades HTML
    const doc = new DOMParser().parseFromString(decodedHtml, "text/html");
    return doc.body.textContent || "";
  };

  useEffect(() => {
    const scrollContainer = scrollRef.current;
    if (scrollContainer) {
      startAutoScroll();
    }
    //@ts-ignore
  }, [startAutoScroll, pautasVis]);

  useEffect(() => {
    const db = getFirestore();

    const ordersRef = collection(
      db,
      "users",
      `belacruz@eleg`,
      "sessoes",
      `${roomId}`,
      "pautas"
    );
    const queryRef = query(
      ordersRef,
      where("leituraVis", "==", true),
      limit(1)
    );

    onSnapshot(queryRef, (querySnapshot) => {
      querySnapshot.docs.map((doc) => {
        const data = doc.data();
        visualizarPauta(data.idPauta);
      });
    });
  }, []);

  const visualizarPauta = (id: string) => {
    const db = getFirestore();
    const pautaDocRef = doc(db, "users", "belacruz@eleg", "pautas", id); // Usando 'doc' para pegar um documento específico

    // Obtenção dos dados da pauta específica
    onSnapshot(pautaDocRef, (docSnapshot) => {
      if (docSnapshot.exists()) {
        const data = docSnapshot.data();

        //@ts-ignore
        const labelCorrespondente = simplesOptions.find(
          (opcao) => opcao.value === data.pautaLegislativa
        );

        // Salvando os dados da pauta visível
        const pautaData = {
          id: docSnapshot.id,
          pautaTexto: stripHtml(data?.expressoes),
          //@ts-ignore
          pautaLegislativaLabel: labelCorrespondente.label,
          ...data,
        };
        //@ts-ignore
        setpautasVis(pautaData);
      } else {
        console.log("Pauta não encontrada!");
      }
    });
  };

  //@ts-ignore
  const labelCorrespondente = simplesOptions.find(
    //@ts-ignore
    (opcao) => opcao.value === pautasVis.pautaLegislativa
  );

  return (
    <div className="min-h-screen flex flex-col justify-between p-0 bg-gray-900">
      <div>
        <Card className="min-w-[100%] h-22 items-center bg-gray-900 p-0 ">
          <CardHeader className="flex flex-col items-center">
            <h1 className="text-5xl font-extrabold  uppercase text-gray-50">
              Câmara Municipal de Bela Cruz
            </h1>
            <Divider className="bg-amber-300 my-2 h-[8px] " />
            <p className="text-3xl font-sans  text-gray-50 uppercase">
              {/* @ts-ignore */}
              {sessao.sessao} SESSÃO{" "}
              {sessao.tipoSessao === "extraordinaria"
                ? "EXTRAORDINÁRIA"
                : "ORDINÁRIA"}{" "}
              {sessao.periodo === undefined
                ? ""
                : sessao.periodo === "1"
                ? "DO 1° PERÍODO DA LEGISLATURA"
                : "DO 2° PERÍODO DA LEGISLATURA"}{" "}
              ({sessao.legislatura})
            </p>
          </CardHeader>
        </Card>
      </div>

      <div className="flex gap-8 h-[30rem]">
        {
          //@ts-ignore
          pautasVis?.pautaTexto != undefined && (
            <div className="px-9">
              <ScrollShadow
                hideScrollBar
                ref={scrollRef}
                style={{
                  overflowY: "auto",
                  maxHeight: "36rem",
                  height: "33rem",
                }}
              >
                <p className="text-3xl font-GeneralSansSemiBold text-white mb-3">
                  {/* @ts-ignore */}
                  Nº {pautasVis?.numero} - {labelCorrespondente?.label}
                </p>
                <p className="text-3xl text-justify font-GeneralSansMedium text-white mb-3">
                  {/* @ts-ignore */}
                  {pautasVis?.pautaTexto.replace(/<\/?[^>]+(>|$)/g, "")}
                </p>
              </ScrollShadow>
            </div>
          )
        }
      </div>

      <div>
        <Divider className="bg-gray-700 h-[18px]" />

        <div className="grid h-full w-full grid-cols-3 ">
          <div className="flex flex-col h-full">
            <div className="p-1 border-1 border-gray-700 h-full text-5xl text-center font-bold text-gray-50">
              {format(new Date(), "HH:mm:ss")}
            </div>
            <div className="p-1 border-1 border-gray-700 h-full text-2xl text-center font-normal text-gray-50">
              {format(new Date(), "dd/MM/yyyy")}
            </div>
          </div>

          <div className="flex h-full w-full flex-row justify-between">
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-green-500">
                SIM
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full w-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-red-500">
                NÃO
              </div>
            </div>
            <div className="flex h-full w-full flex-col justify-between">
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                0
              </div>
              <div className="p-1  h-full  border-1 border-slate-600 text-3xl text-center font-bold text-yellow-400">
                ABST
              </div>
            </div>
          </div>

          <div className=" h-full w-full flex flex-col justify-between">
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-white">
              <span className="text-2xl font-semibold ">PARLAMENTARES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length}
              </span>
            </div>
            <div className="p-1 w-full flex flex-row justify-between px-16 border-1 border-slate-600 h-full text-3xl text-center font-bold text-red-500">
              <span className="text-2xl font-semibold ">AUSENTES</span>
              <span className="text-2xl font-semibold ">
                {presencaParlamentares.length -
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length}
              </span>
            </div>
            <div className="p-1 h-full w-full flex flex-row justify-between px-16 border-1 border-slate-600 text-2xl text-center font-normal text-blue-400">
              <span className="text-2xl font-bold ">PRESENTES</span>
              <span className="text-2xl font-bold ">
                {
                  presencaParlamentares.filter(
                    (item) => (item as any).presenca === true
                  ).length
                }
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
